/**
 * UnvUI/Icons — re-export единого Icon-компонента.
 *
 * Промежуток-101%, Wave U: используется в action-кнопках, тулбарах
 * и заголовках вместо unicode-эмодзи. Регистр имён — `components/Icons/icons-registry`.
 */
import IconBase from '../Icons/Icon'

export const Icon = IconBase
export default IconBase
